import { render, staticRenderFns } from "./OfficeDetail.vue?vue&type=template&id=8c951822"
import script from "./OfficeDetail.vue?vue&type=script&lang=js"
export * from "./OfficeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports